import styled, { css } from 'styled-components';
import { Link as LinkRouter } from 'react-router-dom';

import { colors, spacing } from '../../../styles/theme';

export const Wrapper = styled.nav`
  display: flex;
  padding-top: ${spacing('2')};
  justify-content: center;
  align-items: center;
  z-index: 10;
`;

export const Menu = styled.ul`
  position: sticky;
  top: ${spacing('2')};
  display: flex;
  width: 980px;
  height: 70px;
  padding: ${spacing('1')} ${spacing('2')};
  justify-content: space-between;
  align-items: center;
  border-radius: 6px;
  background-color: ${colors('white.base')};
  box-shadow: 0px 4px 10px 2px ${colors('black.10')};
  box-sizing: border-box;
  font-size: 14px;
`;

export const Image = styled.img`
  display: block;
  height: 40px;
`;

export const Item = styled.li`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  color: #000;
  text-decoration: none;
  position: relative;
`;

const LinkStyles = css`
  display: flex;
  padding: 4px ${spacing('2')} 4px ${spacing('1')};
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  color: ${colors('black.base')};
  text-decoration: none;
  box-sizing: border-box;

  strong {
    margin-right: ${spacing('1')};
    padding-left: ${spacing('2')};
    font-size: 18px;
    font-weight: 500;
  }

  small {
    opacity: 0.4;
    font-size: 12px;
    transform: translateY(-50%);
    text-transform: uppercase;
  }
`;

export const Link = styled(LinkRouter)`
  ${LinkStyles}
`;

export const Text = styled.p`
  ${LinkStyles}

  margin-right: 42px;
`;
